import { Moment } from 'moment';
import DriveAsset from './DriveAsset';
import DriveBookingStatus from '../constants/DriveBookingStatus';
import DriveBookingType from '../constants/DriveBookingType';
import DriveRenter from './DriveRenter';
import DriveCheckInOut from './DriveCheckInOut';
import DriveBilling from './DriveBilling';
import DriveEditableSettings from './DriveEditableSettings';
import MediaFile2 from '@/general/models/MediaFile2';

export default class DriveBookingDetails {
  id!: number;
  status: DriveBookingStatus | null = null;
  type: DriveBookingType | null = null;
  scheduledFrom: Moment | null = null;
  scheduledTill: Moment | null = null;
  driveBookingFleetSourceId: number | null = null;
  driveBookingPartyName: string | null = null;
  lastSynchronizedBy: string | null = null;
  lastSynchronizedOn: Moment | null = null;
  driveBookingAsset: DriveAsset | null = null;
  renter: DriveRenter | null = null;
  checkIn: DriveCheckInOut | null = null;
  checkOut: DriveCheckInOut | null = null;
  billings: DriveBilling[] = [];
  editableSettings: DriveEditableSettings | null = null;
  medias: Array<MediaFile2> = [];
  comment = '';
  invoiceAmount: number | null = null;

  updateSynchronizationInfo(lastSynchronizedOn: Moment | null, lastSynchronizedBy: string | null): void {
    this.lastSynchronizedOn = lastSynchronizedOn;
    this.lastSynchronizedBy = lastSynchronizedBy;
  }
}
